import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
/** The modern module setting: rental-style look, frozen checkbox / S.No / first column / Actions,
 *  overlay filters with chips. Module wrappers pass this to DataTableDefaultsProvider. */
export const MODERN_TABLE_DEFAULTS = { appearance: 'modern', freezeColumns: true, filterMode: 'overlay' };
const DataTableDefaultsContext = React.createContext({});
export function DataTableDefaultsProvider({ value, children }) {
    return _jsx(DataTableDefaultsContext.Provider, { value: value, children: children });
}
export const useDataTableDefaults = () => React.useContext(DataTableDefaultsContext);
